import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ModalWithConfirmation from 'components/ModalWithConfirmation';
import { FERTILIZER_EVENT_CREATE_MODAL } from 'scenes/Fertilizer/constants';
import FertilizerEventFinalForm from '../FertilizerEventFinalForm';

interface ConnectedProps {
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = ConnectedProps & DispatchProps;

export class FertilizerEventCreateModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [FERTILIZER_EVENT_CREATE_MODAL]: undefined
        });
    };

    render(): React.ReactElement {
        const { isOpen } = this.props;

        return (
            <CurrentSeasonInProgressGate>
                <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <ModalWithConfirmation
                        size="fullscreen"
                        open={isOpen}
                        centered={false}
                        onCloseClick={this.handleClose}
                        closeIcon
                        className="spray-event-modal"
                        showConfirmation
                    >
                        <ErrorBoundary
                            namespace="fertilizerEventCreateModal"
                            FallbackComponent={<ErrorBoundaryAlert />}
                        >
                            <FertilizerEventFinalForm title="New Fertilizer Schedule" />
                        </ErrorBoundary>
                    </ModalWithConfirmation>
                </RoleGate>
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, any, ConnectedProps>(
    {
        isOpen: makeSelectQueryStringBooleanValue(FERTILIZER_EVENT_CREATE_MODAL)
    }
);

export default connect(mapStateToProps, {
    updateQueryString
})(FertilizerEventCreateModalComponent);
